import { toShortStr } from "../utils/index.js";
const ROOCH_BECH32_PREFIX = "rooch";
const ROOCH_ADDRESS_LENGTH = 32;
class Address {
  constructor(input) {
    this.rawAddress = input;
  }
  toStr() {
    return this.rawAddress;
  }
  toShortStr(shortOpt = {
    start: 6,
    end: 6
  }) {
    return toShortStr(this.rawAddress, shortOpt);
  }
}
export {
  Address,
  ROOCH_ADDRESS_LENGTH,
  ROOCH_BECH32_PREFIX
};
//# sourceMappingURL=address.js.map
